import State from './State';
export default {
    other: {
        value: 0,
        label: 'Other',
        is_root_item: true,
        key: 'other',
        typeform: null
    },
    probate: {
        value: 1,
        label: 'Probate',
        is_root_item: true,
        description: 'Probate is a court-supervised process for determining and gathering the assets of a deceased person, known as the decedent, paying their debts, and distributing their assets to their beneficiaries and heirs.',
        key: 'probate',
        child_item_keys: [
            'probate_hearing_creditors',
            'probate_hearing',
            'probate_hearing_estate_trust',
            'probate_creditors',
            'probate_sale',
            'w3H2nY',
            'nvP2b5rX',
            'aubLQkUw'
        ],
        states: [State.kansas.value, State.colorado.value]
    },
    delinquent_taxpayers: {
        value: 2,
        label: 'Delinquent Taxpayers',
        is_root_item: true,
        description: 'Delinquent taxes refer to any amount of tax debt owed to the IRS. When there\\u2019s a delinquent account, it means the due date for the tax return or whatever established liability has passed and yet the amount owed remains unpaid.',
        key: 'delinquent_taxpayers',
        typeform: 'oedoT0',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    custom: {
        value: 3,
        label: 'Custom',
        is_root_item: true,
        description: "If you don't see the type of Public Notice you need, you can choose this option to create a notice from scratch.",
        key: 'custom',
        typeform: 'yrNuK9',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    ordinance: {
        value: 4,
        label: 'Ordinance',
        is_root_item: true,
        description: 'Most cities are required to place Public Notices to announce changes to city ordinances.',
        key: 'ordinance',
        typeform: 'oRg70h',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    resolution: {
        value: 5,
        label: 'Resolution',
        is_root_item: true,
        description: 'Most cities are required to place Public Notices to announce the adoption of new resolutions.',
        key: 'resolution',
        typeform: 'afzUPJ',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    name_change: {
        value: 6,
        label: 'Name Change',
        is_root_item: true,
        description: 'When someone files a petition to change their legal name, it required a hearing in the district court. A Public Notice must be published to announce the hearing.',
        key: 'name_change',
        typeform: 'Pmvnou',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    school_elections: {
        value: 7,
        label: 'School Elections',
        is_root_item: true,
        description: 'This is the description for school elections. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'school_elections',
        typeform: 'Min1RK',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    vehicle_auctions: {
        value: 8,
        label: 'Vehicle Auctions',
        is_root_item: true,
        description: 'This is the description for vehicle auctions. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'vehicle_auctions',
        typeform: 'Jm67Vc',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    bid_proposals: {
        value: 9,
        label: 'Bid Proposals',
        is_root_item: true,
        description: 'This is the description for bid proposals. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'bid_proposals',
        typeform: 'h6yZbM',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    elections: {
        value: 10,
        label: 'Elections',
        is_root_item: true,
        description: 'This is the description for elections. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'elections',
        typeform: 'p4PGaH',
        child_item_keys: [
            'voter_registration',
            'election_machine_testing',
            'primary_election',
            'general_election',
            'request_for_candidates',
            'special_election',
            'tJCgkzVw',
            'QtTnN8fx',
            'WOkX93rr'
        ],
        states: [State.kansas.value, State.colorado.value]
    },
    zoning_planning: {
        value: 11,
        label: 'Zoning and Planning',
        is_root_item: true,
        child_item_keys: [
            'special_permit_for_construction',
            'special_use_permit',
            'rezoning_hearing'
        ],
        description: 'TODO',
        key: 'zoning_planning',
        states: [State.kansas.value]
    },
    mortage_foreclosure: {
        value: 12,
        label: 'Mortage Foreclosure',
        is_root_item: true,
        description: 'This is the description for mortage foreclosure. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'mortage_foreclosure',
        typeform: 'BMpO4S',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    personal: {
        value: 13,
        label: 'Personal',
        is_root_item: true,
        description: 'This is the description for personal Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'personal',
        child_item_keys: ['child_adoption', 'child_in_need', 'divorce_petition'],
        states: [State.kansas.value]
    },
    sheriffs_sale: {
        value: 14,
        label: "Real Estate Sheriff's Sale",
        is_root_item: true,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'sheriffs_sale',
        typeform: 'UT5ceq',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    quarterly_report: {
        value: 15,
        label: 'Quarterly Report',
        is_root_item: true,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'quarterly_report',
        typeform: 'FycdIq',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    budget_hearing: {
        value: 16,
        label: 'Notice of Budget Hearing',
        is_root_item: true,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'budget_hearing',
        typeform: 'sSKrnf',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_creditors: {
        value: 17,
        label: 'Notice of Hearing and Notice to Creditors',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_creditors',
        typeform: 'UT5ceq',
        child_item_keys: [
            'probate_hearing_creditors_705',
            'probate_hearing_creditors_506',
            'probate_hearing_creditors_52'
        ],
        states: [State.kansas.value]
    },
    probate_hearing: {
        value: 18,
        label: 'Notice of Hearing',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing',
        typeform: 'UT5ceq',
        child_item_keys: ['probate_hearing_general', 'probate_hearing_realestate'],
        states: [State.kansas.value]
    },
    probate_hearing_general: {
        value: 19,
        label: 'Notice of Hearing - General',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_general',
        typeform: 'UT5ceq',
        child_item_keys: [
            'probate_hearing_general_403',
            'probate_hearing_general_557',
            'probate_hearing_general_632'
        ],
        states: [State.kansas.value]
    },
    probate_hearing_realestate: {
        value: 20,
        label: 'Notice of Hearing - Real Estate',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_realestate',
        typeform: 'UT5ceq',
        child_item_keys: [
            'probate_hearing_realestate_303',
            'probate_hearing_realestate_803',
            'probate_hearing_realestate_1647'
        ],
        states: [State.kansas.value]
    },
    probate_hearing_estate_trust: {
        value: 21,
        label: 'Notice of Hearing and Notice to Estate and Trust Creditors',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_estate_trust',
        typeform: 'TjSRd4',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_creditors: {
        value: 22,
        label: 'Notice to Creditors',
        is_root_item: true,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_creditors',
        typeform: 'RxAzkA',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_sale: {
        value: 23,
        label: 'Notice of Sale',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_sale',
        typeform: 'wdftli',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_creditors_705: {
        value: 24,
        label: 'Form 705',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_creditors_705',
        typeform: 'jsr60d',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_creditors_506: {
        value: 25,
        label: 'Form 506',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_creditors_506',
        typeform: 'HcWjBD',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_creditors_52: {
        value: 26,
        label: 'Form 52',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_creditors_52',
        typeform: 'MSAhhR',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_general_403: {
        value: 27,
        label: 'Form 403',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_general_403',
        typeform: 'NyfHiy',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_general_557: {
        value: 28,
        label: 'Form 557',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_general_557',
        typeform: 'vdUZmF',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_general_632: {
        value: 29,
        label: 'Form 632',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_general_632',
        typeform: 'vdUZmF',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_realestate_303: {
        value: 30,
        label: 'Form 303',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_realestate_303',
        typeform: 'etqxCq',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_realestate_803: {
        value: 31,
        label: 'Form 803',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_realestate_803',
        typeform: 'Ne8A43',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    probate_hearing_realestate_1647: {
        value: 32,
        label: 'Form 1647',
        is_root_item: false,
        description: 'This is the description for up Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'probate_hearing_realestate_1647',
        typeform: 'r8NROQ',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    voter_registration: {
        value: 33,
        label: 'Voter Registration',
        is_root_item: false,
        description: 'Options include online voting registration and registration by mail',
        key: 'voter_registration',
        typeform: 'r3AgZB',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    election_machine_testing: {
        value: 34,
        label: 'Election Machine Testing',
        is_root_item: false,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'election_machine_testing',
        typeform: 'osOCb8',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    primary_election: {
        value: 35,
        label: 'Primary Election',
        is_root_item: false,
        description: 'Includes poll times, online voting, early voting, advanced voting',
        key: 'primary_election',
        typeform: 'y3v3Gn',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    general_election: {
        value: 36,
        label: 'General Election',
        is_root_item: false,
        description: 'Includes poll times, online voting, early voting, advanced voting',
        key: 'general_election',
        typeform: 'xv41xG',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    request_for_candidates: {
        value: 37,
        label: 'Request for Candidates',
        is_root_item: false,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'request_for_candidates',
        typeform: 'FQfmk0',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    special_election: {
        value: 38,
        label: 'Special Election',
        is_root_item: false,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'special_election',
        typeform: 'QH4jDk',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    special_permit_for_construction: {
        value: 39,
        label: 'Special Permit for Construction',
        is_root_item: false,
        description: 'TODO',
        key: 'special_permit_for_construction',
        typeform: 'eth4ZK',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    special_use_permit: {
        value: 40,
        label: 'Special Use Permit',
        is_root_item: false,
        description: 'TODO',
        key: 'special_use_permit',
        typeform: 'pMwGrj',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    rezoning_hearing: {
        value: 41,
        label: 'Rezoning',
        is_root_item: false,
        description: 'TODO',
        key: 'rezoning_hearing',
        typeform: 'wZWgNe',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    child_adoption: {
        value: 42,
        label: 'Child Adoption',
        is_root_item: false,
        description: 'This is the description for child adoption. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'child_adoption',
        typeform: 't9LaQwTR',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    child_in_need: {
        value: 43,
        label: 'Child In Need of Care',
        is_root_item: false,
        description: 'This is the description for child in care. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt',
        key: 'child_in_need',
        typeform: 'pvn739uT',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    divorce_petition: {
        value: 44,
        label: 'Divorce Petition',
        is_root_item: false,
        description: 'When a petition for divorce is filed, it is required to publish a Public Notice to notify the divorcee.',
        key: 'divorce_petition',
        typeform: 'CtTK2y1G',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    display_ad: {
        value: 45,
        is_root_item: false,
        key: 'display_ad',
        child_item_keys: [],
        label: 'Display Ad',
        description: 'Large non-text-based ads',
        states: [State.kansas.value]
    },
    abandoned_property: {
        value: 46,
        is_root_item: true,
        key: 'abandoned_property',
        label: 'Abandoned Property',
        description: 'TODO.',
        typeform: 'eJovON',
        child_item_keys: [],
        states: [State.kansas.value]
    },
    notice_of_sale: {
        value: 47,
        label: 'Notice of Sale',
        is_root_item: true,
        description: '',
        key: 'notice_of_sale',
        child_item_keys: ['hY3wi5pg', 'HbQwHT8k'],
        states: [State.colorado.value]
    },
    tNaElIwE: {
        value: 48,
        label: 'Abandoned Property',
        is_root_item: true,
        description: '',
        key: 'tNaElIwE',
        typeform: 'tNaElIwE',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    MD7R1z: {
        value: 49,
        label: 'Adoption',
        is_root_item: true,
        description: '',
        key: 'MD7R1z',
        typeform: 'MD7R1z',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    mzzHJH: {
        value: 50,
        label: 'Name Change',
        is_root_item: true,
        description: '',
        key: 'mzzHJH',
        typeform: 'mzzHJH',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    RARjeQ: {
        value: 51,
        label: 'Ordinance',
        is_root_item: true,
        description: '',
        key: 'RARjeQ',
        typeform: 'RARjeQ',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    w3H2nY: {
        value: 52,
        label: 'Notice to Creditors',
        is_root_item: true,
        description: '',
        key: 'w3H2nY',
        typeform: 'w3H2nY',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    nvP2b5rX: {
        value: 53,
        label: 'Notice of Hearing',
        is_root_item: false,
        description: '',
        key: 'nvP2b5rX',
        typeform: 'nvP2b5rX',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    aubLQkUw: {
        value: 54,
        label: 'Notice of Hearing Without Appearance',
        is_root_item: false,
        description: '',
        key: 'aubLQkUw',
        typeform: 'aubLQkUw',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    cxovwy: {
        value: 55,
        label: 'Resolution',
        is_root_item: true,
        description: '',
        key: 'cxovwy',
        typeform: 'cxovwy',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    hY3wi5pg: {
        value: 56,
        label: 'Vehicle Sale',
        is_root_item: false,
        description: '',
        key: 'hY3wi5pg',
        typeform: 'hY3wi5pg',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    HbQwHT8k: {
        value: 57,
        label: 'Storage Units Public Sale',
        is_root_item: false,
        description: '',
        key: 'HbQwHT8k',
        typeform: 'HbQwHT8k',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    tJCgkzVw: {
        value: 58,
        label: 'Notice of General Election',
        is_root_item: false,
        description: '',
        key: 'tJCgkzVw',
        typeform: 'tJCgkzVw',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    QtTnN8fx: {
        value: 59,
        label: 'Notice of Primary Election',
        is_root_item: false,
        description: '',
        key: 'QtTnN8fx',
        typeform: 'QtTnN8fx',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    WOkX93rr: {
        value: 60,
        label: 'Notice of Cancelled Election',
        is_root_item: false,
        description: '',
        key: 'WOkX93rr',
        typeform: 'WOkX93rr',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    GYz5UgHd: {
        value: 61,
        label: "Semi-Annual Treasurer's Report",
        is_root_item: true,
        description: '',
        key: 'GYz5UgHd',
        typeform: 'GYz5UgHd',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    pJTHK9Nd: {
        value: 62,
        label: "Treasurer's Deed and Tax Lien Sale",
        is_root_item: true,
        description: '',
        key: 'pJTHK9Nd',
        typeform: 'pJTHK9Nd',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    Fsi4X2vv: {
        value: 63,
        label: 'Combined Notice - Foreclosure Sale',
        is_root_item: true,
        description: '',
        key: 'Fsi4X2vv',
        typeform: 'Fsi4X2vv',
        child_item_keys: [],
        states: [State.colorado.value]
    },
    JW5QnWzp: {
        value: 64,
        label: 'Name Change',
        is_root_item: true,
        description: '',
        key: 'JW5QnWzp',
        typeform: 'JW5QnWzp',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    tdAbFthe: {
        value: 65,
        label: 'Fictitious Business Name',
        is_root_item: true,
        description: '',
        key: 'tdAbFthe',
        typeform: 'tdAbFthe',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    Ylo8wHg9: {
        value: 66,
        label: 'Name Change',
        is_root_item: true,
        description: '',
        key: 'Ylo8wHg9',
        typeform: 'Ylo8wHg9',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    SDWa0YzK: {
        value: 67,
        label: 'Fictitious Business Name',
        is_root_item: true,
        description: '',
        key: 'SDWa0YzK',
        typeform: 'SDWa0YzK',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    bhOfT43Q: {
        value: 68,
        label: 'Petition to Administer Estate',
        is_root_item: true,
        description: '',
        key: 'bhOfT43Q',
        typeform: 'bhOfT43Q',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    jFayXDR2: {
        value: 69,
        label: 'Summons Citation',
        is_root_item: true,
        description: '',
        key: 'jFayXDR2',
        typeform: 'jFayXDR2',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    wake_weekly_notice_to_creditors: {
        value: 73,
        label: 'Notice to Creditors',
        is_root_item: true,
        description: '',
        key: 'wake_weekly_notice_to_creditors',
        typeform: 'Sjx4VzdZ',
        child_item_keys: [],
        states: [],
        requiredPublications: 4
    },
    // FNP
    fnp_orphans: {
        value: 74,
        label: "Orphan's Court",
        is_root_item: true,
        description: '',
        key: 'fnp_orphans',
        typeform: 'G9h5LWVg',
        child_item_keys: [],
        states: [],
        requiredPublications: 2
    },
    fnp_name_change: {
        value: 75,
        label: 'Name Change',
        is_root_item: true,
        description: '',
        key: 'fnp_name_change',
        typeform: 'rfTq8Wm2',
        child_item_keys: [],
        states: [],
        requiredPublications: 1
    },
    fnp_notice_to_creditors_appt: {
        value: 76,
        label: 'Appt Foreign Personal Rep',
        is_root_item: true,
        description: '',
        key: 'fnp_notice_to_creditors_appt',
        typeform: 'rUYeESNX',
        child_item_keys: [],
        states: [],
        requiredPublications: 3
    },
    fnp_notice_to_creditors: {
        value: 77,
        label: 'Reg Estate Notice to Creditors',
        is_root_item: true,
        description: '',
        key: 'fnp_notice_to_creditors',
        typeform: 'Ydnkfabw',
        child_item_keys: [],
        states: [],
        requiredPublications: 3
    },
    fnp_small_estate_notice: {
        value: 78,
        label: 'Small Estate Notice to Creditors',
        is_root_item: true,
        description: '',
        key: 'fnp_small_estate_notice',
        typeform: 'yU7oa5vs',
        child_item_keys: [],
        states: [],
        requiredPublications: 1
    },
    fnp_order_nisi: {
        value: 79,
        label: 'Notice of Sale',
        is_root_item: true,
        description: '',
        key: 'fnp_order_nisi',
        typeform: 'oWkezWyS',
        child_item_keys: [],
        states: [],
        requiredPublications: 3
    },
    CnOi6hm9: {
        value: 80,
        label: 'Mesa Courts Consolidated Divorce',
        is_root_item: true,
        description: '',
        key: 'CnOi6hm9',
        typeform: 'CnOi6hm9',
        child_item_keys: [],
        requiredPublications: 1,
        states: [State.colorado.value]
    },
    oQXMY0Qi: {
        value: 81,
        label: 'Mesa Courts Divorce',
        is_root_item: true,
        description: '',
        key: 'oQXMY0Qi',
        typeform: 'oQXMY0Qi',
        child_item_keys: [],
        requiredPublications: 5,
        states: [State.colorado.value]
    },
    YEhlUaaE: {
        value: 82,
        label: 'Mesa Courts Name Change',
        is_root_item: true,
        description: '',
        key: 'YEhlUaaE',
        typeform: 'YEhlUaaE',
        child_item_keys: [],
        requiredPublications: 3,
        states: [State.colorado.value]
    },
    HXauYLoL: {
        value: 83,
        label: 'Mesa Courts Custody',
        is_root_item: true,
        description: '',
        key: 'HXauYLoL',
        typeform: 'HXauYLoL',
        child_item_keys: [],
        requiredPublications: 5,
        states: [State.colorado.value]
    }
};
